import React, { useEffect, useState } from "react";
import { Box, Divider, HStack, Stack, Text } from "@chakra-ui/react";
import { GET_URL_CLASSIFICATION } from "../../../graphqlExternal/operations/operations";
import { TitleLink } from "../TitleLink";
import { ClassificationsGroup } from "../pastReview/ClassificationsGroup";
import { CorrectionButtons } from "../predictiveCorrections/correctionsButtons";
import { useHitlFilters } from "..";
import { useQuery } from "@apollo/client";
import { ComponentLoading } from "../../../components/loading/ComponentLoading";
import { CollapsibleClassification } from "./CollapsibleClassification";
import { GET_PREDICTED_URL_DATA } from "../../../graphql/operations/campaignOperations/operations";
import { TiTickOutline } from "react-icons/ti";

interface PredictedUrlsListProps {
  classificationData: string;
  rejectedClassificationData: string;
  url: string;
  predictedFromUrl: string;
}

export const PredictedUrlsList = ({
  classificationData,
  rejectedClassificationData,
  url,
  predictedFromUrl,
}: PredictedUrlsListProps) => {
  const hitlFilters = useHitlFilters();
  const [isPredictionsAccepted, setIsPredictionsAccepted] = useState(false);

  const { data: predictedData, error: predictedError } = useQuery(
    GET_PREDICTED_URL_DATA,
    {
      variables: {
        url: url,
      },
      fetchPolicy: "cache-and-network",
    }
  );

  useEffect(() => {
    if (predictedData && predictedData !== undefined && predictedData.predictiveCorrectionsStatus !== null) {
      setIsPredictionsAccepted(
        predictedData.predictiveCorrectionsStatus.isApproved
      );
    }
  }, [predictedData]);

  const { data, loading, error } = useQuery(GET_URL_CLASSIFICATION, {
    context: {
      clientName: "illumaDbEndpoint",
      type: "graphql",
    },
    variables: {
      publisher: hitlFilters.publisherFilter.value,
      url: url,
    },
    fetchPolicy: "cache-and-network",
  });

  if (loading) {
    return <ComponentLoading text={"Loading predictions..."} />;
  }
  if (error || predictedError) {
    return <></>;
  }

  const { __typename, ...classificationEntry } =
    data?.urlClassification.results;
    
    

  const formattedClassification = JSON.stringify(classificationEntry);
  
  
  

  return (
    <Box mx={0} my={6}>
      <Divider borderColor={"muted"} mb={5} />

      <TitleLink
        showNote={false}
        url={url}
        showLink={true}
        reviewButton={true}
        showOverlay={false}
      />
      <Stack
        direction={{ base: "column", md: "row" }}
        spacing={4}
        mt={4}
        w="97%"
        ml={4}
      >
        {classificationData && classificationData !== null && (
          <Box flex="1" mb={4}>
            <ClassificationsGroup
              classification={classificationData}
              classicationType={"Accepted"}
              backgroundColor={"tagGreen.default"}

            />
          </Box>
        )}
        {rejectedClassificationData && rejectedClassificationData !== null && (
          <Box flex="1" mb={4}>
            <ClassificationsGroup
              classification={rejectedClassificationData}
              classicationType={"Rejected"}
              backgroundColor={"tagRed"}
              
            />
          </Box>
        )}
      </Stack>

      <CollapsibleClassification classificationData={formattedClassification} />

      <HStack>
        <Box
          color="tagGreen.dark"
          border="green"
          borderWidth="2px"
          borderRadius="1px"
          marginLeft={4}
        >
          {isPredictionsAccepted && (
            <HStack align="center" spacing={1}>
              <Text
                fontWeight={"semibold"}
                fontSize={"15px"}
                whiteSpace="nowrap"
              >
                Predictions Accepted
              </Text>
              <Box>
                <TiTickOutline width={20} height={20} color="green" />
              </Box>
            </HStack>
          )}
        </Box>

        <Box
          mt={20}
          mr={5}
          width="98%"
          display={"flex"}
          justifyContent={"flex-end"}
        >
          <CorrectionButtons
            urlQuery={url}
            predictedFromUrl={predictedFromUrl}
            originalclassification={formattedClassification}
          />
        </Box>
      </HStack>
    </Box>
  );
};
